'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fetching;
var _reduxPromiseMiddleware = require('redux-promise-middleware');
var _constants = require('./constants');
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var initialState = {
  auth: {},
  user: {},
  loggingIn: false,
  loginError: '',
  verifyingThirdparty: false,
  thirdpartyVerifyError: '',
  thirdpartyVerified: false,
  updatingPassword: false,
  updatingPasswordError: '',
  passwordResetHashValid: false,
  passwordResetHashError: false,
  requestingPasswordReset: false,
  passwordResetError: false,
  passwordHasBeenReset: false,
  isRequestingNewPassword: false,
  newPasswordError: '',
  newPasswordHasBeenSet: false,
  passwordResetCredentials: {
    hash: '',
    loginId: ''
  },
  contactPrefs: {
    fetching: (_fetching = {}, _defineProperty(_fetching, _constants.contactPrefsFormIds.contact, false), _defineProperty(_fetching, _constants.contactPrefsFormIds.interests, false), _fetching)
  },
  staffId: undefined,
  // For gtm tracking
  loginAttempts: 0,
  loginResult: '',
  emailHash: ''
};

// Helper method in case the error doesn't come back nicely
function getError(action, defaultError) {
  if (action.payload && action.payload.response && action.payload.response.data && action.payload.response.data.error && action.payload.response.data.error.description) {
    return action.payload.response.data.error.description;
  }
  return defaultError;
}
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  switch (action.type) {
    case _constants.actionTypes.LOGIN + '_' + _reduxPromiseMiddleware.PENDING:
    case _constants.actionTypes.REFRESH_TOKEN + '_' + _reduxPromiseMiddleware.PENDING:
    case _constants.actionTypes.THIRDPARTY_LOGIN + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          loggingIn: true,
          loginResult: '',
          loginError: ''
        });
      }
    case _constants.actionTypes.LOGIN + '_' + _reduxPromiseMiddleware.REJECTED:
    case _constants.actionTypes.REFRESH_TOKEN + '_' + _reduxPromiseMiddleware.REJECTED:
    case _constants.actionTypes.THIRDPARTY_LOGIN + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, initialState, {
          thirdpartyVerified: state.thirdpartyVerified,
          loginError: getError(action, 'Sorry there was a problem logging in.'),
          loginResult: 'failure',
          loginAttempts: state.loginAttempts + 1
        });
      }
    case _constants.actionTypes.UNAUTHORIZED:
      {
        return Object.assign({}, initialState, {
          loginError: 'Session expired'
        });
      }
    case _constants.actionTypes.LOGIN + '_' + _reduxPromiseMiddleware.FULFILLED:
    case _constants.actionTypes.REFRESH_TOKEN + '_' + _reduxPromiseMiddleware.FULFILLED:
    case _constants.actionTypes.THIRDPARTY_LOGIN + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        var _action$payload$data = action.payload.data,
          expiresIn = _action$payload$data.expires_in,
          access_token = _action$payload$data.access_token,
          refresh_token = _action$payload$data.refresh_token,
          user = _action$payload$data.user,
          scope = _action$payload$data.scope;
        var expires = Date.now() + (expiresIn - 30) * 1000;
        return Object.assign({}, state, action.meta.staffId ? {
          staffId: action.meta.staffId
        } : null, {
          auth: {
            token: access_token,
            refreshToken: refresh_token,
            clientId: action.meta.clientId,
            expires: expires
          },
          user: Object.assign({}, user, {
            scope: scope
          }),
          loginError: '',
          loggingIn: false,
          loginResult: 'success',
          loginAttempts: state.loginAttempts + 1,
          emailHash: action.meta.emailHash || state.emailHash
        });
      }
    case '' + _constants.actionTypes.SET_LOAD_ERROR:
      {
        return Object.assign({}, state, {
          loginError: action.payload
        });
      }
    case _constants.actionTypes.THIRDPARTY_VERIFY + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          verifyingThirdparty: true,
          thirdpartyVerifyError: ''
        });
      }
    case _constants.actionTypes.THIRDPARTY_VERIFY + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          verifyingThirdparty: false,
          thirdpartyVerifyError: 'Sorry there was an issue verifying the user. Please use the link in the email.'
        });
      }
    case _constants.actionTypes.THIRDPARTY_VERIFY + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          verifyingThirdparty: false,
          thirdpartyVerified: true,
          thirdpartyVerifyError: ''
        });
      }
    case _constants.actionTypes.UPDATE_PASSWORD + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          updatingPassword: true
        });
      }
    case _constants.actionTypes.UPDATE_PASSWORD + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          updatingPassword: false,
          updatingPasswordError: getError(action, 'Sorry there was a problem updating your password.')
        });
      }
    case _constants.actionTypes.UPDATE_PASSWORD + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          updatingPassword: false,
          updatingPasswordError: ''
        });
      }
    case _constants.actionTypes.RESET_PASSWORD + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          requestingPasswordReset: true,
          passwordResetError: false,
          passwordHasBeenReset: false
        });
      }
    case _constants.actionTypes.RESET_PASSWORD + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          passwordResetError: true,
          requestingPasswordReset: false,
          passwordHasBeenReset: false
        });
      }
    case _constants.actionTypes.RESET_PASSWORD + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          passwordHasBeenReset: true,
          passwordResetError: false,
          requestingPasswordReset: false
        });
      }
    case _constants.actionTypes.RESET_PASSWORD_RESET:
      {
        return Object.assign({}, state, {
          passwordHasBeenReset: false,
          passwordResetError: false,
          requestingPasswordReset: false
        });
      }
    case _constants.actionTypes.NEW_PASSWORD + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          isRequestingNewPassword: true,
          newPasswordError: '',
          newPasswordHasBeenSet: false
        });
      }
    case _constants.actionTypes.NEW_PASSWORD + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          isRequestingNewPassword: false,
          newPasswordError: getError(action, 'Sorry there was a problem updating your password.'),
          newPasswordHasBeenSet: false
        });
      }
    case _constants.actionTypes.NEW_PASSWORD + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          isRequestingNewPassword: false,
          newPasswordError: '',
          newPasswordHasBeenSet: true,
          passwordResetCredentials: {
            hash: '',
            loginId: ''
          }
        });
      }
    case _constants.actionTypes.SAVE_PASSWORD_RESET_CREDENTIALS:
      {
        return Object.assign({}, state, {
          passwordResetCredentials: {
            hash: action.hash,
            loginId: action.loginId
          }
        });
      }
    case _constants.actionTypes.CHECK_PASSWORD_RESET_HASH + '_' + _reduxPromiseMiddleware.PENDING:
      {
        return Object.assign({}, state, {
          passwordResetHashValid: false,
          passwordResetHashError: false
        });
      }
    case _constants.actionTypes.CHECK_PASSWORD_RESET_HASH + '_' + _reduxPromiseMiddleware.FULFILLED:
      {
        return Object.assign({}, state, {
          passwordResetHashValid: true,
          passwordResetHashError: false
        });
      }
    case _constants.actionTypes.CHECK_PASSWORD_RESET_HASH + '_' + _reduxPromiseMiddleware.REJECTED:
      {
        return Object.assign({}, state, {
          passwordResetHashValid: false,
          passwordResetHashError: getError(action, 'Sorry, the email reset link has expired or is invalid.')
        });
      }
    case _constants.actionTypes.ASSIGN_EMAIL:
      {
        return Object.assign({}, state, {
          user: Object.assign({}, state.user, {
            requiresNewEmailAddress: false
          })
        });
      }
    case _constants.actionTypes.UPDATE_USER:
      {
        return Object.assign({}, state, {
          user: Object.assign({}, state.user, action.newProps)
        });
      }
    case _constants.actionTypes.FETCH_CUSTOMER_PREFS + '_' + _reduxPromiseMiddleware.PENDING:
      return Object.assign({}, state, {
        contactPrefs: Object.assign({}, state.contactPrefs, {
          fetching: Object.assign({}, state.contactPrefs.fetching, _defineProperty({}, action.meta.formId, true))
        })
      });
    case _constants.actionTypes.FETCH_CUSTOMER_PREFS + '_' + _reduxPromiseMiddleware.FULFILLED:
      return Object.assign({}, state, {
        contactPrefs: Object.assign({}, state.contactPrefs, {
          fetching: Object.assign({}, state.contactPrefs.fetching, _defineProperty({}, action.meta.formId, false))
        })
      });
    case _constants.actionTypes.LOGOUT:
      return Object.assign({}, state, {
        loginError: '',
        loginAttempts: 0,
        loginResult: '',
        emailHash: ''
      });
    default:
      return state;
  }
};